import http from './http.service';
import {download} from './helper.service';

class ContractService {
    constructor() {
        if (ContractService.instance) {
            return ContractService.instance;
        }

        ContractService.instance = this;
    }

    contracts() {
        return http.get('/contract').then(res => res.data);
    }

    currentContracts() {
        return http.get('/contract/current').then(res => res.data);
    }

    pastContracts(dates) {
        return http.get('/contract/past', {params: {start: dates[0], end: dates[1]}}).then(res => res.data);
    }

    contract(contractId) {
        return http.get(`/contract/${contractId}/show`).then(res => res.data);
    }

    pdf(contractId, contractNum, lang) {
        return http.download(`/contract/${contractId}/pdf?lang=${lang}`).then(res => {
            const file = {
                mime_type: 'application/pdf',
                filename: `${lang === 'et' ? 'Leping' : 'Contract'}_${contractNum}`
            };
            download(res.data, file);
        });
    }

    store(bookingId, data) {
        return http.post(`/contract/${bookingId}/store`, data).then(res => res.data);
    }

    storeEmpty(data) {
        return http.post('/contract/store/empty', data).then(res => res.data);
    }

    destroy(contractId) {
        return http.delete(`/contract/${contractId}/destroy`).then(res => res.data);
    }
}

export default new ContractService();
